import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import { login } from '../utils/api';
import ReactQuill from "react-quill-new";
 import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import {API_URL} from "../utils/api";
import axios  from "axios";

const AddBlogLayer = () => {
  const [imagePreview, setImagePreview] = useState(null);
   const [title, setTitle] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [content, setContent] = useState("");

  const [titleErr, setTitleErr] = useState(false);
  const [thumbnailErr, setThumbnailErr] = useState(false);
  const [contentErr, setContentErr] = useState(false);
   const navigate = useNavigate();
   let activeuser =localStorage.getItem('activeUser');
   activeuser =  JSON.parse(activeuser);
   

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
     // const src = URL.createObjectURL(e.target.files[0]);
      //setImagePreview(src);
       
      var targetFile = e.target.files[0];
      console.log('targetFile', targetFile);
      console.log('targetFilename',  targetFile.name);
      let filename = targetFile.name;
   
     const src = URL.createObjectURL(targetFile);
     console.log(src);
     setThumbnailErr(false);
 
     setThumbnail(targetFile);
     setImagePreview(src);
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setThumbnailErr(true);

  };
  const quillRef = useRef(null);
  const [value, setValue] = useState(``);
  // eslint-disable-next-line no-unused-vars
  const [isHighlightReady, setIsHighlightReady] = useState(false);

  useEffect(() => {
    // Load highlight.js configuration and signal when ready
    hljs?.configure({
      languages: [
        "javascript",
        "ruby",
        "python",
        "java",
        "csharp",
        "cpp",
        "go",
        "php",
        "swift",
      ],
    });
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleSave = () => {
    const editorContent = quillRef.current.getEditor().root.innerHTML;
    console.log("Editor content:", editorContent);
  };

  // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
  const modules = isHighlightReady
    ? {
        syntax: {
          highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
        },
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      }
    : {
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "formula",
  ];
  const [formData, setFormData] = useState({
    title: '',
    Content: '',
  });

 
  const handleSubmit = () => {
     if(title != "" && thumbnail != "" && content != ""){
    var formData = {
      title : title,
      image : thumbnail,
      content : content
    };
    console.log(formData);
    axios.post(process.env.REACT_APP_API_BASE_URL+"blog-add", { ...formData }, {
      headers: {
        "content-type": "multipart/form-data"
      },
      
    })
      .then((res) => {
          console.log(res.data);
          // return false;
        if(res.data.status === true){
            toast.success('Blog added sucessfully!!');
            setTimeout(() => {
              navigate('/'+activeuser.user_type+'/blog');
            }, 2000);
        }
        else{
            toast.success("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        toast.error(err);
      });

    } else {
     
      if(title == ""){
        setTitleErr(true);
      }
      if(thumbnail == ""){
        setThumbnailErr(true);
      } 
      if(content == ""){
        setContentErr(true);
      }
  
    }
  }


  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Add New Post</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            <form  className='d-flex flex-column gap-20'>
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Post Title:{" "}
                </label>
                <input
                  type='text'
                  className={titleErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                  id='title'
                  placeholder='Enter Post Title'
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setTitleErr(false);
                    if(e.target.value == ""){
                      setTitleErr(true);
                    }
                   }}
                />
                 {titleErr && (
                        <span className="error-message">
                            {'Title is mandatory'}
                        </span>
                    )}   
              </div>
              
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Content
                </label>
                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                  <div className='height-200'>
                    {/* Toolbar */}
                    <div id='toolbar-container'>
                      <span className='ql-formats'>
                        <select className='ql-font'></select>
                        <select className='ql-size'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-bold'></button>
                        <button className='ql-italic'></button>
                        <button className='ql-underline'></button>
                        <button className='ql-strike'></button>
                      </span>
                      <span className='ql-formats'>
                        <select className='ql-color'></select>
                        <select className='ql-background'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-script' value='sub'></button>
                        <button className='ql-script' value='super'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-header' value='1'></button>
                        <button className='ql-header' value='2'></button>
                        <button className='ql-blockquote'></button>
                        <button className='ql-code-block'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-list' value='ordered'></button>
                        <button className='ql-list' value='bullet'></button>
                        <button className='ql-indent' value='-1'></button>
                        <button className='ql-indent' value='+1'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-direction' value='rtl'></button>
                        <select className='ql-align'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-link'></button>
                        <button className='ql-image'></button>
                        <button className='ql-video'></button>
                        <button className='ql-formula'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-clean'></button>
                      </span>
                    </div>

                    {/* Editor */}
                    <ReactQuill
                      ref={quillRef}
                      theme='snow'
                      modules={modules}
                      formats={formats}
                      placeholder='Compose an epic...'
                      value={content}
                      onChange={(e) => {
                        setContent(e);
                    setContentErr(false);
                    if(e == "" || e == "<p><br></p>"  || e == "<p</p>"){
                      setContentErr(true);
                    }
                      }}
                    />
                     {contentErr && (
                        <span className="error-message">
                            {'Content is mandatory'}
                        </span>
                    )}   
                  </div>
                </div>
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemoveImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-file'
                        type='file'
                        hidden
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
                   {thumbnailErr && (
                        <span className="error-message">
                            {'Attachment is mandatory'}
                        </span>
                    )}
                </div>
              </div>
              <button type="button" onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddBlogLayer;
